import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React from "react";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";

const StatisticsDashboard = () => {
    const privileges = secureLocalStorage.getItem("privileges");

    const delay_time = VARIABLES.delayTime;

    const { useFetch } = useAPIQuery({
        key: "insight",
        endpoint: "/api/insight/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        refetchOnReconnect: true,
    });

    const { useFetch: fetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData, isLoading: isGenericLoading } = fetchGeneric({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const showCard = (card) => {
        const cardDetails = genericData?.typemaster?.find(
            (key) => key.value === card.privilege_value
        );
        console.log(card);
        console.log(cardDetails);
        if (cardDetails) {
            return cardDetails;
        }
    };

    const randomColors = [
        "#FFE99A",
        "#FFAAAA",
        "#BBFBFF",
        "#CDC1FF",
        "#C4D7FF",
        "#FFA24C",
        "#ff6f61",
        "#f4a361",
        "#4de286",
        "#ffa07a",
        "#9470dc",
    ];

    const cardData = [
        {
            privilege_value: "clients_board",
            title: "Clients",
            total_count: 22,
            todays_count: 0,
        },
        {
            privilege_value: "suppliers_board",
            title: "Suppliers",
            total_count: 18,
            todays_count: 0,
        },
        {
            privilege_value: "operators_board",
            title: "Operators",
            total_count: 3,
            todays_count: 0,
        },
        {
            privilege_value: "machines_board",
            title: "Machines",
            total_count: 11,
            todays_count: 0,
        },
        {
            privilege_value: "quality_parameters_board",
            title: "Quality Parameters",
            total_count: 119,
            todays_count: 0,
        },
        {
            privilege_value: "quality_rules_board",
            title: "Quality Rules",
            total_count: 34,
            todays_count: 0,
        },
        {
            privilege_value: "items_board",
            title: "Items",
            total_count: 332,
            todays_count: 0,
        },
        {
            privilege_value: "boms_board",
            title: "BOMS",
            total_count: 227,
            todays_count: 0,
        },
    ];

    const hexToRGBA = (hex, opacity) => {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    const renderTrend = (card, index) => {
        const hex = randomColors[index];

        return (
            <div className="mt-2 justify-content-center d-flex">
                <span
                    className={`badge px-2 py-1 w-100 d-flex justify-content-between align-items-center`}
                    style={{
                        fontSize: "0.75rem",
                        fontWeight: "500",
                        backgroundColor: hexToRGBA(hex, 0.1),
                        color: "#000",
                        border: "none",
                        borderRadius: "8px",
                    }}
                >
                    <span> {card.title} added today </span>
                    <span className="me-3"> {card.todays_count}</span>
                </span>
            </div>
        );
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm d-flex align-items-center">
                <div className="nk-block-head-content">
                    <h3 className="nk-block-title">Dashboard</h3>
                </div>
                {isLoading ||
                    (isGenericLoading && (
                        <div
                            className="spinner-border text-primary ms-2"
                            role="status"
                        >
                            <span className="sr-only"></span>
                        </div>
                    ))}
            </div>
            <div className="nk-block">
                {isLoading || isGenericLoading ? (
                    <p className="text-muted">Loading...</p>
                ) : data && data?.data?.length > 0 ? (
                    (() => {
                        let cardsToRender = data?.data?.filter((card) => {
                            const cardDetails = showCard(card);
                            return privileges?.includes(cardDetails?.value);
                        });

                        console.log(cardsToRender);

                        return cardsToRender?.length > 0 ? (
                            <div className="row mb-1 gy-5 gx-2">
                                {cardsToRender?.map((card, index) => {
                                    const cardDetails = showCard(card);
                                    return (
                                        <div
                                            key={index}
                                            className="col-lg-3 col-sm-12 p-1"
                                        >
                                            <div
                                                className="card border-0 shadow-sm h-100 d-flex overflow-hidden"
                                                style={{ borderRadius: "12px" }}
                                            >
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{
                                                        top: 0,
                                                        left: 0,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    {cardDetails.description ? (
                                                        <img
                                                            width="30"
                                                            height="30"
                                                            src={
                                                                cardDetails.description
                                                            }
                                                            alt=" "
                                                        />
                                                    ) : (
                                                        <em
                                                            className="icon ni ni-users fs-6"
                                                            style={{
                                                                color: randomColors[
                                                                    index
                                                                ],
                                                            }}
                                                        ></em>
                                                    )}
                                                </div>
                                                <div className="card-body p-3 pt-1 d-flex flex-column">
                                                    <div className="d-flex justify-content-between align-items-center pe-2">
                                                        <div>
                                                            <h5 className="title mb-1 fw-normal">
                                                                {card.title}
                                                            </h5>
                                                        </div>
                                                        <h2 className="fw-bold text-normal mb-0">
                                                            {card.total_count}
                                                        </h2>
                                                    </div>
                                                    <div className="mt-auto">
                                                        {renderTrend(
                                                            card,
                                                            index
                                                        )}
                                                    </div>
                                                </div>
                                                <div
                                                    className={`w-100`}
                                                    style={{
                                                        height: "4px",
                                                        backgroundColor:
                                                            randomColors[index],
                                                        borderBottomLeftRadius:
                                                            "12px",
                                                        borderBottomRightRadius:
                                                            "12px",
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <p className="text-muted">No data found</p>
                        );
                    })()
                ) : (
                    <p className="text-muted">No data available</p>
                )}
            </div>
        </>
    );
};

export default StatisticsDashboard;
